import VendorTypeahead, { DATA_SOURCES, DefaultSuggestionList } from '@xo-union/tk-component-vendor-typeahead';
import { FieldProps } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';

import TypeaheadFooter from './TypeaheadFooter';

interface Props extends FieldProps {
  // @ts-ignore
  label;
  index: number;
  disabled: boolean;
  onChange: Function;
  onChangeSource: Function;
  resetFields?: Function;
  googleOnly: boolean;
  allowCustomVendor: boolean;
  onClickAddCustom?: Function;
}

export const Typeahead: React.FC<Props> = ({
  field: { value },
  resetFields,
  label,
  disabled,
  onChange,
  googleOnly,
  allowCustomVendor,
  onClickAddCustom,
  ...rest
}) => {
  const [propChanges, setPropChanges] = useState(0);

  const [source, setSource] = useState(googleOnly ? DATA_SOURCES.GOOGLE : DATA_SOURCES.LOCAL);

  useEffect(() => {
    setPropChanges(propChanges + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  // @ts-ignore
  const switchSource = (e, inputSource): void => {
    e.preventDefault();
    if (inputSource === 'custom' && onClickAddCustom) {
      onClickAddCustom();
    } else {
      setSource(inputSource);
    }
  };

  // @ts-ignore
  const renderSuggestionList = (props): JSX.Element => (
    <Fragment>
      <DefaultSuggestionList source={source} {...props} />
      {!googleOnly && (
        <TypeaheadFooter source={source} switchSource={switchSource} allowCustomVendor={allowCustomVendor} />
      )}
    </Fragment>
  );

  // @ts-ignore
  const resetOnEmpty = (e): void => {
    if (!e.length && resetFields) {
      resetFields();
    }
  };

  return (
    <Fragment>
      {source !== 'custom' && (
        <VendorTypeahead
          defaultInputValue={value}
          name={label}
          source={source}
          storefrontSearchParams={{
            filters: [
              '1572f50a-93b6-40ea-9492-d8cec37f0c44', //reception category UUID
              // 'e1c95d05-7b35-4ec3-9312-1e47d33300c3'   //ceremony category UUID
            ],
            limit: '4',
          }}
          onInputChange={resetOnEmpty}
          // @ts-ignore
          onChange={(selectedObject): void => onChange(selectedObject, source)}
          key={`reloads${propChanges}`}
          disabled={disabled}
          renderSuggestionList={renderSuggestionList}
          {...rest}
        />
      )}
    </Fragment>
  );
};

export default Typeahead;
